import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaceCaptureComponent } from 'src/app/shared/components/face-capture/face-capture.component';

@Component({
  selector: 'app-tutorial-photo-modal',
  templateUrl: './tutorial-photo-modal.component.html',
  styleUrls: ['./tutorial-photo-modal.component.css']
})
export class TutorialPhotoModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<TutorialPhotoModalComponent>) { }

  public allowTakePhoto: boolean = false;
  public imageResultRef: string = '';
  public takingPhoto: boolean = false

  ngOnInit(): void { }

  close() {
    this.matDialogRef.close(false);
  }

  clickTakePhoto() {
    this.matDialogRef.close(true);
  }
}